import  normalize from 'json-api-normalize';

export class AddressModel {
  public static parseAddress(addressJson: any): AddressModel {
    const normalizedData = normalize(addressJson).get([
      'organization',
      'address_line1',
      'address_line2',
      'locality',
      'administrative_area',
      'postal_code',
      'region',
      'country_code'
    ]);

    return new AddressModel({
      organization: normalizedData.organization,
      address1: normalizedData.address_line1,
      address2: normalizedData.address_line2,
      city: normalizedData.locality,
      state: normalizedData.administrative_area,
      zipCode: normalizedData.postal_code,
      region: normalizedData.region,
      countryCode: normalizedData.country_code
    });
  }

  public organization: string;
  public address1: string;
  public address2: string;
  public city: string;
  public state: string;
  public zipCode: string;

  public region: string;
  public countryCode: string;

  constructor(values?: Partial<AddressModel>) {
    Object.assign(this, values);
  }

  public hasAddress(): boolean {
    return (
      !this.isEmpty(this.address1) &&
      !this.isEmpty(this.city) &&
      !this.isEmpty(this.state) &&
      !this.isEmpty(this.zipCode)
    );
  }

  public toHTMLString(displayCountryCode = false): string {
    if (this.hasAddress()) {
      const org = this.organization ? `${this.organization}<br/>` : '';
      const addrss2 = this.address2 ? `${this.address2}<br/>` : '';
      const country = displayCountryCode ? `<br/>${this.countryCode}` : '';

      return ''
        .concat(org)
        .concat(`${this.address1}<br>`)
        .concat(`${addrss2}`)
        .concat(`${this.city}, ${this.state} ${this.zipCode}`)
        .concat(`${country}`)
        .trim();
    }

    return '';
  }

  private isEmpty(value: string): boolean {
    return value === null || value === undefined || value === '';
  }
}
